/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import Ratings from "./features/ratings";

const ManageRatings = () => {
  return (
    <>
      <Layout>
        <section className="main_area">
          <Ratings />
        </section>
      </Layout>
    </>
  );
};
export default ManageRatings;
